// const fs = require('fs');
// const path = require('path');

// Pfad zur Datei (kann angepasst werden)
// const filePath = path.join(__dirname, 'component.json');

// Hilfsfunktion: Satzzeichen entfernen, kleinschreiben und tokenisieren
function tokenize(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s]/g, '') // Satzzeichen entfernen
    .split(/\s+/)            // in Wörter splitten
    .filter(Boolean)        // leere Strings entfernen
    .filter(str => isNaN(str) && str.length > 2)
}
function tokenize2(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s]/g, '') // Satzzeichen entfernen
    .split(/\s+/)            // in Wörter splitten
    .filter(Boolean)        // leere Strings entfernen
    .map(str => isNaN(str)? str: "#")
    .map(str => str.replace(/\d+(?=s|min|x|\*)/g, "#"))
    .filter((str, index, arr) => index === 0 || str !== arr[index - 1])
}

// n-Gramme erzeugen
function ngrams(tokens, n) {
  const result = [];
  for (let i = 0; i <= tokens.length - n; i++) {
    result.push(tokens.slice(i, i + n));
  }
  return result;
}

// Häufigkeiten zählen
function countFrequency(items) {
  const freqMap = new Map();
  for (const item of items) {
    const key = Array.isArray(item) ? item.join(';') : item;
    freqMap.set(key, (freqMap.get(key) || 0) + 1);
  }
  return freqMap;
}

// Top N ausgeben
function getTopN(freqMap) {
  return [...freqMap.entries()]
    .sort((a, b) => b[1] - a[1])
    .filter(a => a[1] > 2)
    // .slice(0, n);
}

export function createAutoFills(lines){
  let unigrams = [];
  let bigrams = [];
  let trigrams = [];

  let newLines = [];
  let res = []
  for(let line in lines){
    let data = lines[line];
    // Text tokenisieren
    // const tokens = tokenize(data);
    const tokens2 = tokenize2(data);
    const newLine = tokens2.join(" ").replace(/^# /, "");
    newLines = [...newLines, newLine];
    newLines = newLines.filter(line => line.replace("\\n", "#").length > 3);

    // n-Gramme generieren
    // unigrams = [...unigrams ,...tokens];
    // bigrams = [...bigrams ,...ngrams(tokens, 2)];
    // trigrams = [...trigrams ,...ngrams(tokens, 3)];
  }
  unigrams = newLines;
  bigrams = ngrams(newLines, 2);
  trigrams = ngrams(newLines, 3);

  // Häufigkeiten zählen
  const unigramCounts = countFrequency(unigrams);
  const bigramCounts = countFrequency(bigrams);
  const trigramCounts = countFrequency(trigrams);

  // Ausgabe
  console.log('Top 1-Wort Keywords:');
  for(const [word, count] of getTopN(unigramCounts)){
    console.log(`${word}: ${count}`);
    res = [...res, word];
  }

  console.log('\nTop 2-Wort Phrasen:');
  for(const [phrase, count] of getTopN(bigramCounts)){
    console.log(`${phrase}: ${count}`);
  }

  console.log('\nTop 3-Wort Phrasen:');
  for(const [phrase, count] of getTopN(trigramCounts)){
    console.log(`${phrase}: ${count}`);
  }
  return res
}

// Datei einlesen und Keywords extrahieren
// fs.readFile(filePath, 'utf8', (err, file) => {
//   if (err) {
//     console.error('Fehler beim Lesen der Datei:', err);
//     return;
//   }
//
//   let lines = file.split('\n').map(line => line.split("\\n")).flat()
//
//   createAutoFills(lines);
//
// });
